import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context';
import { ROUTES } from '../constants';

export function PrivateRoute() {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? <Outlet /> : <Navigate to={ROUTES.LOGIN} replace />;
}
